// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_Qmt","cls2":"FeedbackPopover-cls2_skj FeedbackPopover-cls1_Qmt"};